@use '../../styles/mixins.scss' as mixins;
@use '../../styles/border.scss' as border;
@use '../../styles/button.scss' as button;
@use '../../styles/icon.scss' as icon;
@use '../../styles/text.scss' as text;
@use '../../styles/typography.scss' as typography;

.wrapper {
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &.disabled .label {
    @include mixins.disabled;
  }
}

.checkbox {
  all: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: border.$border-width solid border.$border-default;
  background-color: button.$button-checkbox-default;
  overflow: hidden;
  cursor: pointer;
  box-sizing: border-box;
  transition: background-color 0.1s ease;

  &[data-state='checked'],
  &[data-state='indeterminate'] {
    background-color: button.$button-accent-default;
    border-color: transparent;
  }

  &:hover:not([data-disabled]) {
    &[data-state='unchecked'] {
      background-color: button.$button-checkbox-hover;
    }

    &[data-state='checked'],
    &[data-state='indeterminate'] {
      background-color: button.$button-accent-hover;
    }
  }

  &:focus-visible {
    @include mixins.focus-ring;
  }

  &[data-disabled] {
    @include mixins.disabled;
  }
}

.indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  color: icon.$icon-inverse;
}

.label {
  @include typography.text-m-regular;
  color: text.$text-tertiary;
  cursor: pointer;
  user-select: none;
}
